var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyStateAppointmentsPast(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7267 44.4053C23.6657 44.8076 23.6341 45.2188 23.6341 45.6368C23.6341 50.4568 27.8274 54.3641 33 54.3641C38.1726 54.3641 42.3659 50.4568 42.3659 45.6368C42.3659 45.2188 42.3343 44.8076 42.2733 44.4053H65V63.8186C65 65.0236 63.9517 66.0005 62.6585 66.0005H3.34146C2.04831 66.0005 1 65.0236 1 63.8186V44.4053H23.7267Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1463 44.1822C43.1463 49.4038 38.6037 53.6367 33 53.6367C27.3963 53.6367 22.8537 49.4038 22.8537 44.1822C22.8537 44.013 22.8584 43.8449 22.8678 43.6779H1L8.46181 23.1195C8.78349 22.2332 9.67579 21.6367 10.6798 21.6367H55.3202C56.3242 21.6367 57.2165 22.2332 57.5382 23.1195L65 43.6779H43.1322C43.1416 43.8449 43.1463 44.013 43.1463 44.1822Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6645 44.8759C41.6645 48.9107 37.7866 52.9089 33.003 52.9089C28.2193 52.9089 24.3414 48.9107 24.3414 44.8759C24.3414 44.7451 24.3455 43.8879 24.3535 43.7589H8.02734L14.3972 29.3274C14.6718 28.6426 15.4335 28.1816 16.2906 28.1816H49.7153C50.5724 28.1816 51.3341 28.6426 51.6087 29.3274L57.9786 43.7589H41.6524C41.6604 43.8879 41.6645 44.7451 41.6645 44.8759Z",
    fill: "#F0FBFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.97266 43.8276V63.0913C1.97266 63.7943 2.58417 64.3641 3.33851 64.3641H62.6556C63.4099 64.3641 64.0214 63.7943 64.0214 63.0913V43.8276L56.6111 23.4109C56.4234 22.8939 55.9029 22.5459 55.3172 22.5459H10.6769C10.0912 22.5459 9.57069 22.8939 9.38304 23.4109L1.97266 43.8276Z",
    stroke: "#00A4BF",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13281 43.4541H8.02649M11.9289 43.4541C15.0014 43.4541 18.3171 43.4541 21.8762 43.4541C23.3406 43.4541 23.3406 44.4131 23.3406 44.9086C23.3406 49.7286 27.6303 53.6359 32.9219 53.6359C38.2135 53.6359 42.5032 49.7286 42.5032 44.9086C42.5032 44.4131 42.5033 43.4541 43.9677 43.4541H63.4411",
    stroke: "#00A4BF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5889 5.12926L43.9258 14.1861M32.2962 2V14.1861V2ZM11.9258 5.12926L20.5889 14.1861L11.9258 5.12926Z",
    stroke: "#00BADB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateAppointmentsPast);
export default __webpack_public_path__ + "static/media/empty-state-appointments-past.c02fb75d1df9c5ec99fce9fcc8566f93.svg";
export { ForwardRef as ReactComponent };